import { CircularProgress } from "@mui/material";
import React from "react";

export default function Loader() {
  return (
    <div
      style={{
        width: "100%",
        height: "83vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      <CircularProgress color={"error"} />
    </div>
  );
}
